export const useLocalStorage = () => {
    function localSet(data) {
        Object.keys(data).forEach((key) =>
            // JSON encode data before setting
            localStorage.setItem(key, JSON.stringify(data[key]))
        )
    }
    function localGet(key, { remove, fallback } = { remove: false, fallback: null }) {
        let value

        try {
            value = JSON.parse(localStorage.getItem(key) ?? fallback)
        } catch {
            value = localStorage.getItem(key) ?? fallback
        }

        if (remove) {
            localStorage.removeItem(key)
        }

        return value
    }
    function localRemove(key) {
        if (Array.isArray(key)) {
            key.forEach((k) => localStorage.removeItem(k))
        } else {
            localStorage.removeItem(key)
        }
    }

    return { localSet, localGet, localRemove }
}
